<script setup lang="ts">
defineProps<{
  id?: string,
  icons: string[],
  to: string,
  title: string,
}>();
</script>
<template>
  <NuxtLink :id="id" :to="to">
    <div>
      <UiFaIcon :icon="icons" />
    </div>
    <div>
      {{ title }}
    </div>
  </NuxtLink>
</template>
